<template>
    <b-container
            fluid
            :class="{
            'property-search-container': !onPropertyDetailsPage,
            'mt-4': onPropertyDetailsPage,
        }"
    >
        <keep-alive>
            <property-search-listing-page
                    :property-details-route="propertyDetailsRoute"
                    :search-config="searchConfig"
                    :primary-filters="primaryFilters"
                    :default-location-overwrite="defaultLocationOverwrite"
                    :favorite-option-enabled="favoriteOptionEnabled"
                    :tab-display="tabDisplay"
                    :filterable="filterable"
                    :toggleable="toggleable"
                    :map-config="mapConfig"
                    v-if="!onPropertyDetailsPage"
            />
        </keep-alive>
        <property-details
                v-if="onPropertyDetailsPage"
                :property-search-route="propertySearchRoute"
                :active-action-buttons="activeActionButtons"
                :favorite-option-enabled="favoriteOptionEnabled"
                :show-real-estate-contact-section="showPropertyDetailsRealEstateContactSection"
                :home-ownership-buy-home-modal="homeOwnershipBuyHomeModal"
                :property-app-resource="propertyAppResource"
                :property-images="propertyImages"
        />
    </b-container>
</template>

<script>
    import "./PropertySearchContainer.scss";
    import PropertySearchListingPage from "./PropertySearchListingPage";
    import PropertyDetails from "../components/PropertyDetails/PropertyDetails";

    export default {
        name: "PropertySearchContainer",
        components: {
            PropertySearchListingPage,
            PropertyDetails,
        },

        props: {
            propertySearchRoute: {
                type: [String, Object],
                default: 'property.search',
            },
            propertyDetailsRoute: {
                type: [String, Object],
                default: 'property.details.view',
            },
            activeActionButtons: {
                type: Array,
                default: () => [
                    'tour',
                    'offer',
                    'finance',
                    'trade',
                ]
            },
            primaryFilters: {
                type: Array,
                default: () => [
                    'price',
                    'beds',
                    'baths',
                    'homeType',
                    'sale',
                ],
            },
            tabDisplay: {
                type: Boolean,
                default: true,
            },
            searchConfig: {
                type: Object,
                default: () => {
                    return {
                        apiPath: 'elasticsearch'
                    };
                },
            },
            defaultLocationOverwrite: {
                type: Array,
                default: () => [],
            },
            favoriteOptionEnabled: {
                type: Boolean,
                default: true,
            },
            filterable: {
                type: Boolean,
                default: true,
            },
            toggleable: {
                type: Boolean,
                default: false,
            },
            mapConfig: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            showPropertyDetailsRealEstateContactSection: {
                type: Boolean,
                default: false,
            },
            homeOwnershipBuyHomeModal: {
                type: String,
                required: false,
            },
            propertyAppResource: {
                type: Object,
                required: true,
            },
            propertyImages: {
                type: Array,
                required: true
            },
        },

        data() {
            return {};
        },

        computed: {
            onPropertyDetailsPage() {
                let routePath = this.$route.path || '',
                    routeName = this.$route.name || '';

                if (routeName || routePath) {
                    let against = {
                            ...(
                                    typeof this.propertyDetailsRoute == 'string'
                                            ? {name: this.propertyDetailsRoute}
                                            : this.propertyDetailsRoute
                            ),
                            ...{name: 'property.details.view', path: '/property-details/:id'}
                        },
                        againstPath = against.path.split('/')
                            .filter(v => Boolean(v) && (v.indexOf('detail') || v.indexOf('property')))[0],
                        againstName = against.name;

                    return routePath && againstPath && routePath.indexOf(`/${againstPath}`) > -1 ||
                        routeName && againstName && routeName.indexOf(againstName) > -1;
                }

                return false;
            }
        }
    };
</script>
